import dayjs from 'dayjs';

/**
 * Acha a sessão (data+hora) mais relevante de um evento multi-data pra
 * exibição: a de hoje se houver, senão a próxima futura mais próxima, senão
 * a primeira data cadastrada.
 */
export default function findSessionInfo(dates = []) {
    const list = dates || [];

    const today = list.find((d) => d?.date && dayjs(d.date).isSame(dayjs(), 'day'));
    if (today) return { isToday: true, date: today.date, start: today.start };

    const upcoming = [...list]
        .filter((d) => d?.date && dayjs(d.date).isAfter(dayjs(), 'day'))
        .sort((a, b) => new Date(a.date) - new Date(b.date))[0];

    const chosen = upcoming || list[0] || null;
    if (!chosen) return null;

    return { isToday: false, date: chosen.date, start: chosen.start };
}
